/**
 * Normalizes a user entered URL to ensure it has https:// protocol.
 * Handles: google.com, www.google.com, http://google.com, https://google.com
 * Returns empty string for empty/whitespace input.
 */
const normalizeUrl = (url: string | undefined | null): string => {
	if (!url) return "";

	const trimmed = url.trim();
	if (!trimmed) return "";

	// Already has https://
	if (/^https:\/\//i.test(trimmed)) return trimmed;

	// Has http:// — upgrade to https://
	if (/^http:\/\//i.test(trimmed))
		return trimmed.replace(/^http:\/\//i, "https://");

	// Has // prefix (protocol relative)
	if (trimmed.startsWith("//")) return `https:${trimmed}`;

	// No protocol — add https://
	return `https://${trimmed}`;
};

export default normalizeUrl;
